import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ConfigurationsConstants } from '../../configurations/store/configurations.constants'
import { getConfigurationsSelector } from '../../configurations/selectors'
import { IConfigurationsState, IDatasetDeterminationConfig } from '../../configurations/store/configurations.types'
import { getServiceIdSelector } from '../../user/selectors'
import { IClientDataDoc } from '../../../services/clientData.service'
import { OptionsService } from '../services/options.service'
import { Rules } from '../../rules/store/rules.types'
import * as actions from '../store/options.actions'
import { createIndexedRules } from '../../../utilities/runRulesValidation.util'
import { getRulesOptionsSelector } from '../selectors'
import { IRulesOptionsState } from '../store/options.types'

export function* setStateRules() {
  try {
    const { datasetDeterminationConfig }: IConfigurationsState = yield select(getConfigurationsSelector)
    if (!datasetDeterminationConfig) return

    const { datasets }: IDatasetDeterminationConfig = datasetDeterminationConfig
    const serviceId: string = yield select(getServiceIdSelector)
    const optionsService = new OptionsService(serviceId)
    const rulesOptions: IRulesOptionsState = yield select(getRulesOptionsSelector)
    const { stateRules } = rulesOptions
    let updatedStateRules: Rules = [...stateRules]

    for (let i = 0; i < datasets.length; i++) {
      const stateAlreadyLoadedFlag = stateRules.find((rule) => rule.sourceType === datasets[i].dataset)
      if (datasets[i].includeInExport && stateAlreadyLoadedFlag) {
        continue
      } else if (datasets[i].includeInExport) {
        const stateRulesResponse: IClientDataDoc = yield call(
          [optionsService, optionsService.getStateRules],
          datasets[i].dataset
        )
        updatedStateRules = [...updatedStateRules, ...(stateRulesResponse?.entity || [])]
      } else if (stateAlreadyLoadedFlag) {
        updatedStateRules = updatedStateRules.filter((rule) => rule.sourceType !== datasets[i].dataset)
      }
    }

    yield put(actions.setStateRules(updatedStateRules, createIndexedRules(updatedStateRules)))
  } catch (e) {
    yield put(throwPcrException(`setStateRules() error: ${e}`))
  }
}
export function* setStateRulesSaga() {
  yield takeLatest([ConfigurationsConstants.SET_DATASET_DETERMINATION_CONFIG], setStateRules)
}
